/* ============================================================
   ISCA Workwear site-wide custom JS
   Loaded from layout/theme.liquid (defer). Companion to
   assets/isca-custom.css.

   Currently contains: "Done" text button in each collection
   filter dropdown's footer row (next to Clear) — closes the
   panel when finished selecting. Filters apply instantly as
   boxes are ticked; this just dismisses the dropdown. The
   facets re-render via AJAX after every filter change, so a
   MutationObserver re-adds the button after each re-render.
   ============================================================ */
(function () {
  function addDoneButtons() {
    document.querySelectorAll('.facets__panel-content .facets__clear').forEach(function (row) {
      if (row.querySelector('.isca-done')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'isca-done';
      btn.textContent = 'Done';
      btn.setAttribute('aria-label', 'Close filter options');
      row.appendChild(btn);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.isca-done');
    if (!btn) return;
    e.preventDefault();
    var details = btn.closest('details');
    if (details) {
      var summary = details.querySelector('summary');
      if (summary) { summary.click(); } else { details.removeAttribute('open'); }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addDoneButtons);
  } else {
    addDoneButtons();
  }
  new MutationObserver(addDoneButtons).observe(document.documentElement, { childList: true, subtree: true });
})();
